exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-tell-friends {\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);\n  border-radius: 100px 16px 16px 100px;\n}\n.share-button {\n  border-radius: 16px;\n}\n.share-button.btn-facebook {\n  background: linear-gradient(81.84deg, #1C4C91 0%, #3A91F9 98.24%);\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);\n}\n.share-button.btn-twitter {\n  background: linear-gradient(82.24deg, #2FB4FF 0%, #2D9AFF 98.24%);\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);\n}", ""]);

// exports
